import React, {useEffect, useRef, useState} from "react";
import axios from "axios";
import {Button, Card, Grid} from "@mui/material";
import LocationSelectForMain from "./components/LocationSelectForMain";
import {InfoTwoTone, PinDropTwoTone, PinTwoTone, WhatsApp} from "@mui/icons-material";
import Header from "./components/Header";
import {API_URL} from "./config";
import {useParams} from "react-router-dom";

export default function DoctorsByDeparments() {
    const [doctorList, setDoctorList] = useState([])
    const [city, setCity] = useState('');
    const [district, setDistrict] = useState('');
    const [loading, setLoading] = useState(false);
    const [skip, setSkip] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    let param = useParams();

    const isFetching = useRef(false); // Tetiklenme kontrolü için ref kullan

     const trackClick = async (doctorId, eventType) => {
    await fetch(`${API_URL}/doctors/${doctorId}/click`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ event_type: eventType }),
    });
  };
  const formatPhoneNumberForWhatsApp = (phoneNumber) => {
    // Telefon numarasını +90 ülke koduyla uluslararası formata çevir
    const cleanedNumber = phoneNumber.replace(/\D/g, ''); // Sadece sayıları al
    const internationalNumber = `90${cleanedNumber.slice(1)}`; // Başındaki 0'ı çıkar ve 90 ekle
    return `https://wa.me/${internationalNumber}`;
  };

  const handleWhatsAppClick = (doctorId, phoneNumber) => {
    const whatsappLink = formatPhoneNumberForWhatsApp(phoneNumber);
    trackClick(doctorId, 'whatsapp_click');
    window.open(whatsappLink, '_blank');
  };

  const handleMapClick = (doctorId, coordinates) => {
    trackClick(doctorId, 'map_click');

    let mapLink= `https://www.google.com/maps?q=${coordinates.lat},${coordinates.lng}`

    window.open(mapLink, '_blank');
  };


    const handleLoadMore = () => {
        if (!loading && hasMore) {
            fetchDoctors();
        }
    };

    const fetchDoctors = async () => {
        if (isFetching.current || !hasMore) return; // Eğer bir işlem devam ediyorsa yeni istek gönderme

        setLoading(true);
        isFetching.current = true; // İstek gönderildiği için true yap

        try {
            const response = await axios.get(`${API_URL}/doctors-list-by-department`, {
                params: {
                    department: param.department,
                    skip: skip,
                    limit: 20,
                    city: city,
                    district: district,
                }
            });

            const { doctors, next_skip } = response.data;

            if (doctors.length < 20) {
                setHasMore(false); // Daha fazla veri yok
            }

            setDoctorList(prevList => {
                const combinedList = [...prevList, ...doctors];
                // Benzersiz bir liste oluştur (doctor.id'ye göre)
                const uniqueList = Array.from(new Map(combinedList.map(item => [item.id, item])).values());
                return uniqueList;
            });
            setSkip(next_skip); // Skip değerini güncelle
        } catch (error) {
            console.error('Error fetching doctors:', error);
        } finally {
            setLoading(false);
            isFetching.current = false; // İstek tamamlandı
        }
    };

    useEffect(() => {
        setDoctorList([]); // Yeni arama yapılacaksa listeyi temizle
        setSkip(0);
        setHasMore(true);
        fetchDoctors(); // İlk yüklemede çağır
    }, [param.department, city, district]); // Bu bağımlılıklardan biri değiştiğinde çalışır

    return (
        <div className="App">
        <Header />
            <main>
                <p style={{
                    border: 'blue 1px solid',
                    width: '90%',
                    borderRadius: '5px',
                    margin: '0 auto',
                    minHeight: '80px',
                    alignContent: 'center',
                    backgroundColor: 'lightblue'
                }}><InfoTwoTone color={'info'}/> Seçtiğiniz {param.department} branşına ait doktorlar listelenmektedir
                </p>
                <p></p>
                <form className="search-form">
                    <LocationSelectForMain setCity={setCity} setDistrict={setDistrict}/>
                    <Button variant={'contained'} color={'info'} onClick={() => {
                        fetchDoctors()
                    }}>Bul</Button>
                </form>


                <div style={{padding: '10px'}}>

                    <h2> Doktorlar: </h2>
                    {
                        doctorList.length > 0 &&
                        doctorList.map((doctor, index) => {
                                return (

                                    <div key={index}>

                                        <Card style={{
                                            textAlign: "left",
                                            width: '50%',
                                            backgroundColor: '#f8f6f6',
                                            margin: '0 auto ',
                                            boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)',
                                        }}>
                                            <Grid container >
                                                {
                                                    doctor.info?.profile_photo &&
                                                    <Grid item sm={2} xs={6}>
                                                        <img src={'data:image/JPEG;base64,'+doctor.profile_photo} width={'120px'} />
                                                    </Grid>
                                                }


                                                <Grid item sm={5} xs={12}>
                                                    <h4>{doctor.name}</h4>
                                                    <h4>{doctor.hospital}</h4>
                                                    <p>{doctor.address} {doctor.district} / {doctor.city} </p>
                                                    {doctor.whatsapp &&

                                                        <Button
                                                            size={'small'}
                                                            onClick={() => handleWhatsAppClick(doctor.id, doctor.whatsapp)}
                                                            className="whatsapp-link" color={'success'} variant={'contained'}
                                                        >
                                                            <WhatsApp />
                                                            WhatsApp

                                                        </Button>}

                                                  <Button
                                                      size={'small'}
                                                        onClick={() => handleMapClick(doctor.id, doctor.coordinates)}
                                                        className="map-link" variant={'contained'}
                                                    >
                                                        <PinDropTwoTone />
                                                        Haritayı Aç
                                                    </Button>
                                                </Grid>
                                                <Grid item sm={4} xs={12}>
                                                    {doctor.info?.insurance?.selectedOption?.length > 0 && (
                                                        <p>
                                                            <strong>Anlaşmalı Sigortalar</strong>
                                                            { doctor.insurance.selectedOption.map((data,index)=>{
                                                                return (
                                                                    <li key={index}> {data.label}</li>
                                                                )
                                                            }) }
                                                        </p>)
                                                    }
                                                    {doctor.info?.services?.selectedOlanak?.length > 0 && (
                                                        <p>
                                                            <strong>Sunulan Hizmetler</strong>
                                                            { doctor.services.selectedOlanak.map((data,index)=>{
                                                                return (
                                                                    <li key={index}> {data.label}</li>
                                                                )
                                                            }) }
                                                        </p>)
                                                    }
                                                </Grid>
                                            </Grid>
                                        </Card>
                                        <hr style={{borderStyle:"dotted", borderColor:'#ccc'}}></hr>
                                    </div>

                                )

                            }
                        )
                    }
                    {loading && <p>Yükleniyor...</p>}
                    {hasMore && (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleLoadMore}
                            disabled={loading}
                        >
                            Daha Fazla Yükle
                        </Button>
                    )}
                    {!hasMore && <p>Başka doktor bulunamadı.</p>}
                </div>
            </main>


            <footer>

                <div className="social-media-icons">
                    {/* Add social media icons here */}
                </div>
            </footer>

        </div>
    )
}
